import { motion, useReducedMotion } from "framer-motion";
import { Loader2 } from "lucide-react";
import WildRushWorld from "./WildRushWorld";
import { WildRushHome } from "./WildRushHome";

const ACCENT = "#4FA3D9";

// Sim #2 pre-simulation introduction (outside Screens 1–80). Shown only for a fresh public entry with no
// resumable attempt. BEGIN is the single canonical start trigger (one session, one sim_start).
export default function IntroScreen({ onBegin, busy }) {
  const reduce = useReducedMotion();
  const item = (d) => ({ initial: { opacity: 0, y: reduce ? 0 : 10 }, animate: { opacity: 1, y: 0 }, transition: { duration: reduce ? 0.2 : 0.7, delay: reduce ? 0 : d, ease: [0.22, 1, 0.36, 1] } });
  return (
    <div className="relative h-[100dvh] w-full overflow-hidden bg-[#0a0a0a] text-white" data-testid="sim2-intro" style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <div className="absolute inset-0"><WildRushWorld env="title" players={[]} /></div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#06131a] via-[#06131a]/70 to-[#06131a]/25" aria-hidden />

      <div className="absolute inset-x-0 top-0 z-20 flex items-start justify-between p-4 sm:p-6">
        <div className="flex items-center gap-2">
          <WildRushHome />
          <div className="flex items-center gap-1 rounded-full border border-white/15 bg-black/35 px-3.5 py-1.5 backdrop-blur" data-testid="sim2-intro-brand">
            <img src="/adaptience-logo.png" alt="Adaptience" className="h-4 w-auto" />
            <sup className="text-[8px] text-white/50">™</sup>
          </div>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 z-20 p-6 sm:p-10" style={{ paddingBottom: "max(1.5rem, env(safe-area-inset-bottom))" }}>
        <div className="mx-auto max-w-lg">
          <motion.p {...item(0.1)} className="text-[11px] font-semibold uppercase tracking-[0.28em]" style={{ color: ACCENT }} data-testid="sim2-intro-overline">
            An Interactive Life Simulation
          </motion.p>
          <motion.h1 {...item(0.25)} className="mt-3 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl" data-testid="sim2-intro-title">
            Someone I Met Online
          </motion.h1>
          <motion.p {...item(0.4)} className="mt-3 text-sm text-white/70 sm:text-base" data-testid="sim2-intro-sub">
            An online-safety simulation for ages 10–14.
          </motion.p>
          <motion.p {...item(0.55)} className="mt-5 max-w-md text-[16px] leading-relaxed text-white/90 [text-shadow:0_1px_3px_rgba(0,0,0,0.45)]" data-testid="sim2-intro-body">
            You’re about to enter WILD RUSH, a fictional online game. Play naturally and decide what you want to do as things unfold.
          </motion.p>
          <motion.div {...item(0.75)} className="mt-8">
            <button
              onClick={onBegin}
              disabled={busy}
              data-testid="sim2-intro-begin"
              className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-full px-8 text-sm font-semibold uppercase tracking-[0.18em] text-white transition-[transform,opacity] hover:scale-[1.01] active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 disabled:opacity-60 sm:w-auto"
              style={{ background: ACCENT }}
            >
              {busy ? <Loader2 size={16} className="animate-spin" /> : null}
              Begin
            </button>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
